import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const gateList = createAsyncThunk('gate/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `premise_gate`,
            params: {
                ...(data?.pageSize != null ? { pageSize: data.pageSize } : {}),
                ...(data?.currentPage != null ? { pageNo: data.currentPage } : {}),
                'search': data?.search,
                'premise_id': data?.premise_id,
                'in_gate': data?.in_gate,
                'out_gate': data?.out_gate,
                ...(data?.xa ? { xa: true } : {}),
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const gateDetails = createAsyncThunk('gate/details', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `premise_gate/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const addGate = createAsyncThunk('gate/add', async (data) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'premise_gate',
            data: {
                "premise_id": data?.values?.premise_id,
                "gate_name": data?.values?.name,
                "in_gate": data?.values?.in_gate,
                "out_gate": data?.values?.out_gate,
                "allowed_all": data?.values?.all_users_allowed,
                "residents_allowed": data?.values?.is_residents_allowed,
                "staff_allowed": data?.values?.is_staff_allowed,
                "vendor_allowed": data?.values?.is_vendor_allowed,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const updateGate = createAsyncThunk('gate/update', async (data) => {
    try {
        const res = await axios({
            method: 'PUT',
            url: getConfig.API_URL + 'premise_gate',
            data: {
                "gate_id": data?.values?.id,
                "premise_id": data?.values?.premise_id,
                "gate_name": data?.values?.name,
                "in_gate": data?.values?.in_gate,
                "out_gate": data?.values?.out_gate,
                "allowed_all": data?.values?.all_users_allowed,
                "residents_allowed": data?.values?.is_residents_allowed,
                "staff_allowed": data?.values?.is_staff_allowed,
                "vendor_allowed": data?.values?.is_vendor_allowed,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const delGate = createAsyncThunk('gate/delete', async (data) => {
    try {
        const res = await axios({
            method: 'DELETE',
            url: getConfig.API_URL + `premise_gate/${data?.id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const gate = createSlice({
    name: 'gate',
    initialState: {
        list: [],
        details: null,
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(gateList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                if (action.meta.arg?.pageable?.xa) {
                    return
                }
                state.list = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        });

        builder.addCase(gateDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.details = null
            }
        });
    }
})

export default gate.reducer;